import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Box, Typography, Alert, Link } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login, scheduleData } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const coachHashedId = scheduleData.coachHashedId;
    const month = scheduleData.month;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const value = localStorage.getItem(key);
      console.log(`${key}: ${value}`);
    }
  }, [scheduleData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userData = await login(formData);
      //console.log('Login successful:', userData);
      //localStorage.setItem('userId', userData.id);
      //console.log(localStorage.getItem('userId'));
      switch (userData.role) {
        case 'ADMIN':
          navigate('/admin', { replace: true });
          break;
        case 'COACH':
          navigate('/coach', { replace: true });
          break;
        case 'STUDENT':
          navigate('/student', { replace: true });
          break;
        default:
          setError('無效的用戶角色');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(typeof error === 'string' ? error : '登入失敗，請檢查您的認證資訊');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          登入
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {error}
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="電子郵件"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={handleChange}
            value={formData.email}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="密碼"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={handleChange}
            value={formData.password}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            登入
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2">
              還沒有帳號？{' '}
              <Link 
                onClick={() => navigate('/register')}
                variant="body2" 
                sx={{ cursor: 'pointer' }}
              >
                立即註冊
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Login; 